import { Button } from "@/components/ui/button.tsx";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import {  Download, File } from "lucide-react";
import "./AssetPreviewDialog.scss";

interface AssetPreviewDialogProps {
    isOpen: boolean;
    onClose: () => void;
    asset: {
        src?: string;
        file?: any;
        alt?: string;
    } | null;
}

const AssetPreviewDialog = ({ isOpen, onClose, asset }: AssetPreviewDialogProps) => {
    if (!asset) return null;

    const content_type = asset.file?.content_type || 'image/png';
    const isImage = content_type.startsWith('image/');
    const fileName = asset.file?.name || 'asset';

    const handleDownload = () => {
        if (asset.src) {
            const link = document.createElement('a');
            link.href = asset.src;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose} >
            <DialogContent className="asset-preview-dialog">
                <DialogHeader>
                    <DialogTitle className="flex items-center justify-between">
                        <span className="truncate">{fileName}</span>
                        <div className="flex gap-2">
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={handleDownload}
                                className="flex items-center gap-2 mr-8"
                            >
                                <Download className="w-4 h-4" />
                                Download
                            </Button>
                           
                        </div>
                    </DialogTitle>
                </DialogHeader>
                
                <div className="asset-preview-content">
                    {isImage ? (
                        <img
                            src={asset?.src}
                            alt={asset?.alt || fileName}
                            className="max-w-full max-h-[70vh] object-contain rounded-lg"
                        />
                    ) : (
                        <div className="flex flex-col items-center justify-center p-8 text-center">
                            <File className="w-16 h-16 text-gray-400 mb-4" />
                            <h3 className="text-lg font-medium mb-2">{fileName}</h3>
                            <p className="text-gray-500 mb-4">File preview not available</p>
                            <Button
                                variant="outline"
                                onClick={handleDownload}
                                className="flex items-center gap-2"
                            >
                                <Download className="w-4 h-4" />
                                Download File
                            </Button>
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AssetPreviewDialog;
